import classNames from "classnames";
import React from "react";

import { InjectedContentBlock } from "@utils/search/@types/internal/injectedContentBlock";

import { ContentBlockComponent } from "./contentBlock.component";
import "./contentBlock.scss";
import { ContentBlockButton } from "./contentBlockButton.component";
import { ContentBlockLink } from "./contentBlockLink.component";

type ContentBlockComponentProps = {
    content: InjectedContentBlock;
};

const ContentBlock = ({ content }: ContentBlockComponentProps) => {
    const expandImage =
        content.imageUrl && !content.title && !content.description;

    const className = classNames(
        "contentBlock card--all text-reset text-decoration-none d-block h-100",
        expandImage && "contentBlock--image-expanded",
    );

    return !!content.aidenAdvisorId ? (
        <ContentBlockButton
            className={className}
            data-advisor-id={content.aidenAdvisorId}
            data-aiden-mode={"sidebar"}
        >
            <ContentBlockComponent content={content} />
        </ContentBlockButton>
    ) : (
        <ContentBlockLink className={className} url={content.url}>
            <ContentBlockComponent content={content} />
        </ContentBlockLink>
    );
};

export { ContentBlock };
